module.exports = __webpack_public_path__ + "static/8-6fe54be1b5f54eea5f440ea0eb766f31.png";